<div style="margin-top: 20px; margin-left: 20px;">
  <form [formGroup]="settingsForm" autocomplete="off" data-1p-ignore data-lpignore="true" data-protonpass-ignore="true" >
    <legend style="font-weight:bold">Email Settings</legend>
    <div class="mb-3 row" [ngClass]="{'has-error':!serverAddress.valid}">
      <span class="col-lg-2">SMTP Server Address:</span>
      <div class="col-lg-4">
        <input class="form-control" type="text" [formControl]="serverAddress" />
      </div>
    </div>
    @if (serverAddress.hasError('required')) {
      <div class="row">
        <div class="col-lg-6 alert alert-danger">
          SMTP Server Address is required
        </div>
      </div>
    }
    <div class="mb-3 row" [ngClass]="{'has-error':!serverPort.valid}">
      <span class="col-lg-2">SMTP Server Port:</span>
      <div class="col-lg-1">
        <input class="form-control" type="number" [formControl]="serverPort" />
      </div>
    </div>
    @if (serverPort.hasError('required')) {
      <div class="row">
        <div class="col-lg-3 alert alert-danger">
          SMTP Server Port is required
        </div>
      </div>
    }
    @if (serverPort.hasError('minValue') || serverPort.hasError('maxValue')) {
      <div
        class="mb-3 row">
        <div class="col-lg-3 alert alert-danger">
          SMTP Server Port must be in the range 1 - 65535
        </div>
      </div>
    }
    <div class="mb-3 row" [ngClass]="{'has-error':!timeout.valid}">
      <span class="col-lg-2">Timeout (seconds):</span>
      <div class="col-lg-1">
        <input class="form-control" type="number" [formControl]="timeout" />
      </div>
    </div>
    @if (timeout.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-3 alert alert-danger">
          Timeout is required
        </div>
      </div>
    }
    @if (timeout.hasError('minValue') || timeout.hasError('maxValue')) {
      <div
        class="mb-3 row">
        <div class="col-lg-3 alert alert-danger">
          Timeout must be in the range 1 - 200
        </div>
      </div>
    }
    <div class="mb-3 row " [ngClass]="{'has-error':!toAddress.valid}">
      <span class="col-lg-2">Recipient Addresses:</span>
      <div class="col-lg-4">
        <input class="form-control" type="text" [formControl]="toAddress" />
      </div>
    </div>
    @if (toAddress.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-6 alert alert-danger">
          Recipient Addresses is required
        </div>
      </div>
    }
    <div class="mb-3 row" [ngClass]="{'has-error':!fromAddress.valid}">
      <span class="col-lg-2">Sender Address:</span>
      <div class="col-lg-4">
        <input class="form-control" type="text" [formControl]="fromAddress" />
      </div>
    </div>
    @if (fromAddress.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-6 alert alert-danger">
          Sender Address is required
        </div>
      </div>
    }
    <div class="mb-3 row" [ngClass]="{'has-error':!fromName.valid}">
      <span class="col-lg-2">Sender Name:</span>
      <div class="col-lg-4">
        <input class="form-control" type="text" [formControl]="fromName" />
      </div>
    </div>
    @if (fromName.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-6 alert alert-danger">
          Sender Name is required
        </div>
      </div>
    }
    <div class="mb-3 row" [ngClass]="{'has-error':!requiresEncryption.valid}">
      <div class="col-lg-4">
        <input type="checkbox" [formControl]="requiresEncryption" />
        <span class="uv-checkbox-label">SMTP server requires SSL/TLS</span>
      </div>
    </div>
    <div class="mb-3 row" [ngClass]="{'has-error':!requiresAuth.valid}">
      <div class="col-lg-4">
        <input type="checkbox" [formControl]="requiresAuth" />
        <span class="uv-checkbox-label">SMTP server requires authentication</span>
      </div>
    </div>
    <div class="mb-3 row" [ngClass]="{'uv-disabled':!requiresAuth.value, 'has-error':settingsForm.hasError('validUserName')}">
      <span class="col-lg-2">Username:</span>
      <div class="col-lg-4">
        <input class="form-control" type="text" [formControl]="userName" autocomplete="new-userName" data-lpignore="true" />
      </div>
    </div>
    @if (settingsForm.hasError('validUserName')) {
      <div class="mb-3 row">
        <div class="col-lg-6 alert alert-danger">
          Username is required
        </div>
      </div>
    }
    <div class="mb-3 row" [ngClass]="{'uv-disabled':!requiresAuth.value, 'has-error':settingsForm.hasError('validPassword')}">
      <span class="col-lg-2">Password:</span>
      <div class="col-lg-4">
        <input name="disable-pwd-mgr-1" type="password" id="disable-pwd-mgr-1" style="display: none;" value="disable-pwd-mgr-1" />  
        <input name="disable-pwd-mgr-2" type="password" id="disable-pwd-mgr-2" style="display: none;" value="disable-pwd-mgr-2" />
        <input name="disable-pwd-mgr-3" type="password" id="disable-pwd-mgr-3" style="display: none;" value="disable-pwd-mgr-3" />

        <input class="form-control" type="password" [formControl]="password" autocomplete="new-password" data-lpignore="true" />
      </div>
    </div>
    @if (settingsForm.hasError('validPassword')) {
      <div class="mb-3 row">
        <div class="col-lg-6 alert alert-danger">
          Password is required
        </div>
      </div>
    }
    <div class="mb-3 row" [ngClass]="{'uv-disabled':!requiresAuth.value, 'has-error':settingsForm.hasError('passwordsEqual')}">
      <span class="col-lg-2">Confirm Password:</span>
      <div class="col-lg-4">
        <input name="disable-pwd-mgr-4" type="password" id="disable-pwd-mgr-4" style="display: none;" value="disable-pwd-mgr-4" />
        <input name="disable-pwd-mgr-5" type="password" id="disable-pwd-mgr-5" style="display: none;" value="disable-pwd-mgr-5" />
        <input name="disable-pwd-mgr-6" type="password" id="disable-pwd-mgr-6" style="display: none;" value="disable-pwd-mgr-6" />

        <input class="form-control" type="password" [formControl]="confirmPassword" autocomplete="new-confirmPassword" data-lpignore="true" />
      </div>
    </div>
    @if (settingsForm.hasError('passwordsEqual')) {
      <div class="mb-3 row">
        <div class="col-lg-6 alert alert-danger">
          Confirm Password must be the same as Password
        </div>
      </div>
    }
    <div class="mb-3 row" style="margin-top: 15px;">
      <div class="uv-row">
        <span class="col-lg-2">&nbsp;</span>
        <div style="padding-left: 15px; text-align: center;">
          <button type="button" (click)="testEmail()"	pButton icon="fa" label="Test Email"
            [disabled]="!enableTestEmail" >
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
